import { Journey, OrderDetails } from '@tff/types/tff';

export const getFareFamily = (
  outboundJourney?: Journey,
  inboundJourney?: Journey,
  journeysLength?: number,
): string[] => {
  if (journeysLength && journeysLength > 1) {
    return [outboundJourney?.FareFamily ?? '', inboundJourney?.FareFamily ?? ''];
  }
  return [outboundJourney?.FareFamily ?? ''];
};

export const shouldDisableChangeActions = (product?: string): boolean => {
  return product === 'aircruiser';
};

export const getJourneys = (orderDetails: OrderDetails) => {
  const outbound = orderDetails?.Journeys[0];
  const inbound = orderDetails?.Journeys.length > 1 ? orderDetails.Journeys[1] : undefined;
  return { outbound, inbound };
};

export const calculateServicePackageFee = (
  serviceResponse: any,
  passengersCount: number,
): number => {
  if (serviceResponse?.success && 'passengers' in serviceResponse.response.servicePackages) {
    return passengersCount * serviceResponse.response.servicePackages.passengers[0].selectedServicePackage.price.value;
  }
  return 0;
};
